import client from '../../client';
import { notifyUser } from './notification';

import {
  GET_DOMAINS,
  GET_DOMAINS_SUCCESS,
  GET_DOMAINS_FAIL,

  GET_DOMAIN_RECORDS,
  GET_DOMAIN_RECORDS_SUCCESS,
  GET_DOMAIN_RECORDS_FAIL,

  EDIT_RECORD,
  EDIT_RECORD_SUCCESS,
  EDIT_RECORD_FAIL,

  ADD_RECORD,
  ADD_RECORD_SUCCESS,
  ADD_RECORD_FAIL,

  DNS_RECORDS_SEARCH
} from '../constants/dns'

export const getDomains = () => dispatch => {
  dispatch({
    type: GET_DOMAINS
  });

  client
    .get('dns')
    .then(({data}) => {
      dispatch({
        type: GET_DOMAINS_SUCCESS,
        data
      })
    })
    .catch(error => {
      dispatch({
        type: GET_DOMAINS_FAIL,
        error
      })
    })
}

export const getDomainRecords = domain => dispatch => {
  dispatch({
    type: GET_DOMAIN_RECORDS
  });

  client
    .get(`dns/${domain}`)
    .then(({data}) => {
      dispatch({
        type: GET_DOMAIN_RECORDS_SUCCESS,
        data
      })
    })
    .catch(error => {
      dispatch({
        type: GET_DOMAIN_RECORDS_FAIL,
        error
      })
    })
}

export const editRecord = (domain, record) => dispatch => {
  dispatch({
    type: EDIT_RECORD
  })
  notifyUser({
    message: `Record for ${domain} is being modified`,
    type: 'loading'
  })(dispatch)
  client
    .put(`dns/${domain}`, record)
    .then(({data}) => {
      dispatch({
        type: EDIT_RECORD_SUCCESS,
        data: record
      })
      notifyUser({
        message: `${domain} modified`,
        type: 'success'
      })(dispatch)
    })
    .catch(error => {
      dispatch({
        type: EDIT_RECORD_FAIL,
        error
      })
      notifyUser({
        message: `failed to modify ${domain}`,
        type: 'error'
      })(dispatch)
    })
}

export const addRecord = (domain, record) => dispatch => {
  dispatch({
    type: ADD_RECORD
  })
  notifyUser({
    message: `Record for ${domain} is being added`,
    type: 'loading'
  })(dispatch)
  client
    .patch(`dns/${domain}`, record)
    .then(({data}) => {
      dispatch({
        type: ADD_RECORD_SUCCESS,
        data: record
      })
      notifyUser({
        message: `${record.subdomain} added`,
        type: 'success'
      })(dispatch)
    })
    .catch(error => {
      dispatch({
        type: ADD_RECORD_FAIL,
        error
      })
      notifyUser({
        message: `failed to add ${record.subdomain}`,
        type: 'error'
      })(dispatch)
    })
}

export const searchDomainsRecord = (filter) => dispatch => {
  client.post('dns/search', filter)
  .then(res => res.data)
  .then(result => {
    dispatch({
      type: DNS_RECORDS_SEARCH,
      dnsSearchResult: result
    });
  })
  .catch(err => {
    console.error(`Search failed..`, err);
  })
}



// WEBPACK FOOTER //
// ./src/redux/actions/dns.js